import { IUser } from "../../../Models/Models";
import { GetLoginUserDataFailureAction } from "../Types/LoginActionTypes";
import {
    GetAllUsersFailureAction,
    GetAllUsersInitAction,
    GetAllUsersSuccessAction,
    GetUserInitAction,
    GetUserSuccessAction,
    GET_ALL_USERS_FAILURE,
    GET_ALL_USERS_INIT,
    GET_ALL_USERS_SUCCESS,
    GET_USER_FAILURE,
    GET_USER_INIT,
    GET_USER_SUCCESS,
    SetLoadingAllUsersAction,
    SetShowActiveUsersAction,
    SET_LOADING_ALL_USERS,
    SET_SHOW_ACTIVE_USERS
} from "../Types/UserActionTypes";

/** misc */

export const setShowActiveUsers = (showActiveUsers: boolean): SetShowActiveUsersAction => ({
    type: SET_SHOW_ACTIVE_USERS,
    data: showActiveUsers,
});

export const setLoadingAllUsers = (loading: boolean): SetLoadingAllUsersAction => ({
    type: SET_LOADING_ALL_USERS,
    data: loading,
});

/** initiate */

export const getUser = (): GetUserInitAction => ({
    type: GET_USER_INIT,
    data: null,
});

export const getAllUsersInitiate = (): GetAllUsersInitAction => ({
    type: GET_ALL_USERS_INIT,
    data: null,
});

/** success */

export const getUserSuccess = (user: IUser): GetUserSuccessAction => ({
    type: GET_USER_SUCCESS,
    data: user,
});

export const getAllUsersSuccess = (users: IUser[]): GetAllUsersSuccessAction => ({
    type: GET_ALL_USERS_SUCCESS,
    data: users,
});

/** failure */

export const getAllUsersFailure = (errMsg: string): GetAllUsersFailureAction => ({
    type: GET_ALL_USERS_FAILURE,
    data: errMsg,
});

export const getUserFailure = (errMsg: string): GetLoginUserDataFailureAction => ({
    type: GET_USER_FAILURE,
    data: errMsg,
});